import { InputAdornment, TextField } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getDateFormat } from '../../../_helpers/useful-functions';
import CustomReactDatePicker from '../../../components/custom-react-datepicker';
import Spinner from '../../../components/ui/spinner';
import { get, put, del } from '../../../core/client';
import { useAppSelector } from '../../../store';
import { setPage } from '../../../store/features/moments/momentsSlice';
import CreateActionForm from './createActionForm';
import DeleteWarningModal from './deleteWarningModal';
import ModalDialog from './modal';

const CreateAction = () => {
    const initialState = {
        eventDate: null,
        specialDateDetail: '',
        isEdit: false,
    };
    const [state, setState] = useState<any>(initialState);
    const [details, setDetails] = useState<any>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [updateShowModal, setUpdateShowModal] = useState<boolean>(false);
    const [deleteWraningModal, setDeleteWraningModal] = useState<boolean>(false);
    const [isTouched, setIsTouched] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { page } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);

    useEffect(() => {
        if (page.managerDefinedSpecialDateId || page.userSpecialDateMainId) {
            const id = page.managerDefinedSpecialDateId ? page.managerDefinedSpecialDateId : page.userSpecialDateMainId;
            const queryParam = (page.managerDefinedSpecialDateId ? '?userManagerDefinedSpecialDateId=' : '?userSpecialDateMainId=') + id;
            const getActionDetails = async () => {
                const actionDetails = await get<any>(`/users/get-special-day-action-list-async${queryParam}`);
                setDetails(actionDetails.result);
                setState({
                    eventDate: actionDetails.result.specialDateStartDate,
                    specialDateDetail: actionDetails.result.specialDateDetail,
                });
            };
            getActionDetails();
        }
    }, [page]);

    const deleteActions = async () => {
        await del(`users/delete-user-specialdate?managerDefinedSpecialDateId=${page.managerDefinedSpecialDateId}`, '').then((res: any) => {
            dispatch(setPage({ name: 'momentsHome', type: '', id: '' }));
        });
    };

    const handleUpdateAction = async () => {
        if (!state?.eventDate) return;

        const formUpdate = {
            userManagerDefinedSpecialDateId: page.managerDefinedSpecialDateId,
            description: state.specialDateDetail,
            date: state?.eventDate ? getDateFormat({ date_: state.eventDate }) : null,
        };
        const endpoint = 'manager-defined-specialdate/Update';
        await put(endpoint, formUpdate).then((res: any) => {
            if (res.isSuccessful) {
                const queryParam = '?userManagerDefinedSpecialDateId=' + page.managerDefinedSpecialDateId;
                const getActionDetails = async () => {
                    const actionDetails = await get<any>(`/users/get-special-day-action-list-async${queryParam}`);
                    setDetails(actionDetails.result);
                };
                getActionDetails();
                setState({ ...state, isEdit: false });
            }
            setUpdateShowModal(false);
        });
    };

    const deleteWarningOpenModal = () => {
        setDeleteWraningModal(true);
    };
    const handleShowUpdateModal = () => {
        if (state?.eventDate?.length === 0) {
            setIsTouched(true);
            setUpdateShowModal(false);
        } else {
            setUpdateShowModal(true);
        }
    };

    return (
        <div className="create-action">
            {details ? (
                <>
                    <div className="section-02">
                        <a className="c-container-icon" href="#!" onClick={() => dispatch(setPage({ name: 'momentsHome', type: '', id: '' }))}>
                            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
                                    stroke="#6C6C7D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M21.875 13.125L13.125 21.875"
                                    stroke="#6C6C7D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M13.125 13.125L21.875 21.875"
                                    stroke="#6C6C7D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </a>

                        <div className="c-container-text">
                            <h2>{words && words['WEB.createPlan']}</h2>
                            {details && <p>{words && words['WEB.createMomentText']}</p>}
                        </div>
                    </div>

                    <div className="section-03">
                        <div className="micro-card-02">
                            <div className=" c-item-01">
                                {details && !details.teamName && details?.ecUserId?.length > 0 && (
                                    <img
                                        className="c-item-01-A"
                                        src={details.photo ? details.photo : 'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'}
                                        alt={details.photo ? details.photo : 'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'}
                                    />
                                )}
                                <div className="c-item-01-B">
                                    <h5 className="c-unit-01">{details.name + ' ' + (details.surname ? details.surname : '')}</h5>
                                    <p className={page.userSpecialDateMainId ? 'c-unit-02 addUserDefinedSpecialDateId' : 'c-unit-02'}>
                                        {details?.position ? details.position + ' - ' : ''} {details?.departmentName}
                                    </p>
                                    <div className={state?.specialDateDetail?.length > 0 ? 'c-unit-03 addStyle' : 'c-unit-03'}>
                                        <div className="c-unit-03-group">
                                            <div className="c-unit-wrapper">
                                                <div className="c-unit-03-A">
                                                    <div className="c-mikro-unit-01">
                                                        <img src={details.icon} alt={details.icon} />
                                                    </div>
                                                    <span className="c-mikro-unit-02">{details.specialDateType}</span>
                                                </div>

                                                {state?.isEdit ? (
                                                    <CustomReactDatePicker
                                                        name="eventDate"
                                                        isPlanEdit
                                                        setState={setState}
                                                        stateDate={state?.eventDate}
                                                        isTouched={isTouched}
                                                    />
                                                ) : (
                                                    <div className="c-unit-03-B">
                                                        <span>{new Date(details.specialDateStartDate).toLocaleDateString('tr-TR')}</span>
                                                    </div>
                                                )}
                                            </div>
                                            {!page.userSpecialDateMainId && details?.isEditable && (
                                                <div className={state.isEdit ? 'c-unit-04 BgColorChange' : 'c-unit-04'}>
                                                    <TextField
                                                        className="textfield-04"
                                                        id={'specialDateDetail' + state.specialDateDetail}
                                                        value={state.specialDateDetail}
                                                        onChange={e => state.isEdit && setState({ ...state, specialDateDetail: e.target.value })}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <svg
                                                                        width="21"
                                                                        height="20"
                                                                        viewBox="0 0 21 20"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <g clipPath="url(#clip0_3565_25384)">
                                                                            <path
                                                                                d="M10.0355 18.3333C14.6379 18.3333 18.3688 14.6023 18.3688 9.99996C18.3688 5.39759 14.6379 1.66663 10.0355 1.66663C5.43311 1.66663 1.70215 5.39759 1.70215 9.99996C1.70215 14.6023 5.43311 18.3333 10.0355 18.3333Z"
                                                                                fill="white"
                                                                                stroke="#7E7E92"
                                                                                strokeWidth="2"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M10.0356 13.3333V10"
                                                                                stroke="#7E7E92"
                                                                                strokeWidth="2"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                            <path
                                                                                d="M10.0356 6.66663H10.044"
                                                                                stroke="#7E7E92"
                                                                                strokeWidth="2"
                                                                                strokeLinecap="round"
                                                                                strokeLinejoin="round"
                                                                            />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_3565_25384">
                                                                                <rect
                                                                                    width="20"
                                                                                    height="20"
                                                                                    fill="white"
                                                                                    transform="translate(0.0356445)"
                                                                                />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        {details?.isEditable && page?.managerDefinedSpecialDateId && (
                                            <>
                                                {state.isEdit ? (
                                                    <div className="c-unit-03-E">
                                                        <ModalDialog
                                                            message={words && words['WEB.sureToSaveThem']}
                                                            open={updateShowModal}
                                                            setOpen={setUpdateShowModal}
                                                            handleUpdateAction={handleUpdateAction}
                                                        />
                                                        <a href="#!" className="button-08" onClick={handleShowUpdateModal}>
                                                            {words && words['WEB.update']}
                                                        </a>
                                                        <a
                                                            href="#!"
                                                            className="button-08"
                                                            onClick={() =>
                                                                setState({ ...state, eventDate: details?.specialDateStartDate, isEdit: false })
                                                            }>
                                                            {words && words['WEB.giveUp']}
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <DeleteWarningModal
                                                            message={details?.regulatoryAuthorityDescription}
                                                            open={deleteWraningModal}
                                                            setOpen={setDeleteWraningModal}
                                                        />
                                                        {/* kalem ikonu*/}
                                                        <div className="c-unit-03-C">
                                                            <Tooltip
                                                                placement="top"
                                                                arrow
                                                                title={words && words['WEB.updateMoment']}
                                                                className="c-item-02-B">
                                                                <a
                                                                    href="#!"
                                                                    onClick={() =>
                                                                        details?.hasRegulatoryAuthority
                                                                            ? setState({ ...state, isEdit: true })
                                                                            : deleteWarningOpenModal()
                                                                    }>
                                                                    <svg
                                                                        className="light"
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M18 2L22 6"
                                                                            stroke="white"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M7.5 20.5L19 9L15 5L3.5 16.5L2 22L7.5 20.5Z"
                                                                            stroke="white"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                    <svg
                                                                        className="dark"
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M18 2L22 6"
                                                                            stroke="#7E7E92"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M7.5 20.5L19 9L15 5L3.5 16.5L2 22L7.5 20.5Z"
                                                                            stroke="#7E7E92"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </a>
                                                            </Tooltip>
                                                        </div>

                                                        {/* //delete */}
                                                        <div className="c-unit-03-D">
                                                            <ModalDialog
                                                                message={words && words['WEB.sureToDeleteSpecialMoment']}
                                                                open={showModal}
                                                                setOpen={setShowModal}
                                                                deleteActions={deleteActions}
                                                            />
                                                            <Tooltip
                                                                placement="top"
                                                                arrow
                                                                title={words && words['WEB.deleteMoment']}
                                                                className="c-item-02-B">
                                                                <a
                                                                    href="#!"
                                                                    onClick={() =>
                                                                        details?.hasRegulatoryAuthority
                                                                            ? setShowModal(true)
                                                                            : deleteWarningOpenModal()
                                                                    }>
                                                                    <svg
                                                                        className="light"
                                                                        width="25"
                                                                        height="24"
                                                                        viewBox="0 0 25 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M3.53564 6H5.53564H21.5356"
                                                                            stroke="white"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M8.53564 6V4C8.53564 3.46957 8.74636 2.96086 9.12143 2.58579C9.4965 2.21071 10.0052 2 10.5356 2H14.5356C15.0661 2 15.5748 2.21071 15.9499 2.58579C16.3249 2.96086 16.5356 3.46957 16.5356 4V6M19.5356 6V20C19.5356 20.5304 19.3249 21.0391 18.9499 21.4142C18.5748 21.7893 18.0661 22 17.5356 22H7.53564C7.00521 22 6.4965 21.7893 6.12143 21.4142C5.74636 21.0391 5.53564 20.5304 5.53564 20V6H19.5356Z"
                                                                            stroke="white"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M10.5356 11V17"
                                                                            stroke="white"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M14.5356 11V17"
                                                                            stroke="white"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                    <svg
                                                                        width="25"
                                                                        className="dark"
                                                                        height="24"
                                                                        viewBox="0 0 25 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M3.53564 6H5.53564H21.5356"
                                                                            stroke="#7E7E92"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M8.53564 6V4C8.53564 3.46957 8.74636 2.96086 9.12143 2.58579C9.4965 2.21071 10.0052 2 10.5356 2H14.5356C15.0661 2 15.5748 2.21071 15.9499 2.58579C16.3249 2.96086 16.5356 3.46957 16.5356 4V6M19.5356 6V20C19.5356 20.5304 19.3249 21.0391 18.9499 21.4142C18.5748 21.7893 18.0661 22 17.5356 22H7.53564C7.00521 22 6.4965 21.7893 6.12143 21.4142C5.74636 21.0391 5.53564 20.5304 5.53564 20V6H19.5356Z"
                                                                            stroke="#7E7E92"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M10.5356 11V17"
                                                                            stroke="#7E7E92"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M14.5356 11V17"
                                                                            stroke="#7E7E92"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </a>
                                                            </Tooltip>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="c-item-02"></div>
                            <div className="c-item-03">
                                <svg className="c-unit-01" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.5 10L20.5 15L15.5 20"
                                        stroke="#7E7E92"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M4.5 4V11C4.5 12.0609 4.92143 13.0783 5.67157 13.8284C6.42172 14.5786 7.43913 15 8.5 15H20.5"
                                        stroke="#7E7E92"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                <span className="c-unit-02">{details.specialDayDescription}</span>
                            </div>
                        </div>
                    </div>

                    <div className="section-04">
                        <div className="micro-card-03">
                            <div className="c-item-01">
                                <div className="c-unit-01">
                                    <img src={details.icon} />
                                    <h4>
                                        {details.specialDateType + ' '} {words && words['WEB.dayDetails']}
                                    </h4>
                                </div>
                                <div className="c-unit-02">
                                    <p>{details.actionGroupDescription}</p>
                                </div>
                            </div>

                            <div className="c-item-02">
                                <div className="c-unit-01">
                                    <div className="c-unit-01-A">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6023 18.3337 9.99996C18.3337 5.39759 14.6027 1.66663 10.0003 1.66663C5.39795 1.66663 1.66699 5.39759 1.66699 9.99996C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333Z"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.5752 7.49999C7.77112 6.94304 8.15782 6.47341 8.66682 6.17426C9.17583 5.87512 9.77427 5.76577 10.3562 5.86558C10.9381 5.96539 11.4659 6.26792 11.8461 6.71959C12.2263 7.17126 12.4344 7.74292 12.4335 8.33332C12.4335 9.99999 9.93353 10.8333 9.93353 10.8333"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M10 14.1666H10.0083"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <h4>{words && words['WEB.whatCanWeDone']}</h4>
                                    </div>

                                    {details.actionFlow.map((item, index) => (
                                        <div key={'details' + index} className="c-unit-01-B">
                                            <p>
                                                - {item.name} <br />
                                            </p>
                                        </div>
                                    ))}
                                </div>
                                {details.testimonials.length > 0 && (
                                    <div className="c-unit-02">
                                        <div className="c-unit-02-A">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M17.5 12.5C17.5 12.942 17.3244 13.366 17.0118 13.6785C16.6993 13.9911 16.2754 14.1667 15.8333 14.1667H5.83333L2.5 17.5V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5Z"
                                                    stroke="#00A3FF"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <h4>{words && words['WEB.oneOfUs']}</h4>
                                        </div>

                                        <div className="c-unit-02-B">
                                            {details.testimonials.map((item, index) => (
                                                <>
                                                    <p key={'testimonial' + item?.description + index}> “{item?.description}“</p> <br />
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <Spinner />
            )}

            <div className="section-05">
                <CreateActionForm />
            </div>
        </div>
    );
};

export default CreateAction;
